export default "__VITE_ASSET__30e88ae1__"